<div class="p-6">
  @if (connectionPoint) {
    <app-card>
      <div class="flex gap-4">
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md font-semibold">
            {{ 'connectionpoint.masterdata' | translate }}
          </div>

          <app-value-details
            [collection]="connectionpointDetailsMasterData"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md">
            {{ 'connectionpoint.location' | translate }}
          </div>

          <app-value-details
            [collection]="locationMasterData"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
        <div class="w-1/3">
          <div class="bg-gray-100 dark:bg-dark-hover dark:text-dark-text py-2 px-3 rounded-md">
            {{ 'connectionpoint.key' | translate }}
          </div>

          <app-value-details
            [collection]="keyMasterData"
            [data]="connectionPoint"
          ></app-value-details>
        </div>
      </div>
    </app-card>
  }
</div>
